$(document).ready(function() {
    let urlParams = new URLSearchParams(window.location.search);
    let hash = window.location.hash;
    let currentUrl = window.location.href;

    if (urlParams.has('contact_posted') && urlParams.get('contact_posted') === 'true' && hash === '#cart-configure') {
        $(`.variants-selector[data-id="${$.cookie('data-id')}"]`).addClass('selected').siblings().removeClass('selected');
        $(`.variants-option #${$.cookie('data-id')}`).trigger('click');
        
        let cart = $('.popup-cart');
        
        cart.show();
        cart.find('.cart-wrapper').css('right', 0);
        cart.find('.cart-body').hide();
        cart.find('.cart-submitted').css('display', 'flex');
        cart.find('.btn-continue').attr('disabled', false);
    }
    else {
        if (currentUrl.indexOf('challenge?') === -1) {
            let data_ID = $('.variants-selector.selected').data('id');
            $.cookie('data-id', `${data_ID}`, { expires: 7, path: '/' });
        }
        
        let timestamp = $.now();

        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function () {
                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: { note: 'REF: ' + timestamp },
                    dataType: 'json',
                    error: function (xhr, status, error) {
                        console.error('Error updating cart note:', error);
                    }
                });
            },
            error: function (xhr, status, error) {
                console.error('Error clearing cart:', error);
            }
        });

        $('[name="contact[ref]"]').val('REF: ' + timestamp);
    }
});

$('.btn-atc').on('click', function() {
    $('.popup-cart').fadeIn();
    $('.popup-cart .cart-wrapper').css('right', '0');

    $('html').css('overflow', 'hidden');
});
$('.popup-cart .overlay, .popup-cart .cart-close').on('click', function() {
    $('.popup-cart').fadeOut();
    $('.popup-cart .cart-wrapper').css('right', '-100%');

    $('html').css('overflow', 'auto');
});

$(document).on('change', '.popup-cart .form-check-input', function() {
    let parent = $(this).parent().parent().data('check');

    if (parent === 'checkbox-1') {
        let checkedValues = [];
        
        $('.form-check-input').each(function() {
            if ($(this).parent().parent().data('check') === 'checkbox-1' && $(this).prop('checked')) {
                checkedValues.push($(this).val());
            }
        });

        let finalValue = checkedValues.length > 0 ? checkedValues.join(', ') : 'None';
        $('#cart-configure [name="contact[configuration_need]"]').val(finalValue);
    }

    if (parent === 'checkbox-2') {
        let checkedValues = [];
        
        $('.form-check-input').each(function() {
            if ($(this).parent().parent().data('check') === 'checkbox-2' && $(this).prop('checked')) {
                checkedValues.push($(this).val());
            }
        });

        let finalValue = checkedValues.length > 0 ? checkedValues.join(', ') : 'None';
        $('#cart-configure [name="contact[furniture_option]"]').val(finalValue);
    }

    if (parent === 'radio-1') {
        $('#cart-configure [name="contact[ecohome_to_be_ready]"]').val($(this).val());
    }
});

$('.popup-cart .btn-continue').on('click', function() {
    $('.popup-cart .cart-body').hide();
    $('.popup-cart .cart-submitted').hide();
    $('.popup-cart .cart-final').show();
    $('.popup-cart .cart-footer').hide();
});

$('.popup-cart .cart-submitted .back').on('click', function() {
    $('.popup-cart .cart-body').show();
    $('.popup-cart .cart-submitted').hide();
});

$('.popup-cart .cart-final .back').on('click', function() {
    $('.popup-cart .cart-submitted').css('display', 'flex');
    $('.popup-cart .cart-final').hide();
    $('.popup-cart .cart-footer').show();
});

$('.popup-cart .atc-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            window.location.href = '/checkout'
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});